import { useEffect, useState } from 'react';
import { IListItem } from '../../../../components/card/listItem/IListItem';
import ListItem from '../../../../components/card/listItem/listItem';
import ElementTitle from '../../../../components/title/elementTitle/elementTitle';
import ChequesListSkeleton from './chequeListSkeleton';
import { useMutation } from 'react-query';
import { GetCheques } from '../../../../services/cheque.service';
import {
    ICheqeuResponse,
    IGetCheqeuRequest,
} from '../../../../models/cheque.model';
import NestedCard from '../../../../components/card/nestedCard/nestedCard';
import { useDispatch } from 'react-redux';
import { setchequeInfo } from '../../../../redux/cheque/chequeInfoSlice';
import { IContainerApp } from '../../../navigationButtonComponents/loansTab/containerApp/IContainerApp';
import { getFormRejectReasons } from '../../../../services/registration.service';
import { IEntityRejectReasons, IGetFormRejectReasonsRequest, IGetFormRejectReasonsResponse } from '../../../../models/registration.model';
import { IInnerStateCheque } from '../IInnerstate';
import { useAppBar } from '../../../../components/appBar/appBarContext';
import { changeRouteType, getNextInnerState, getpervInnerState } from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import CustomisedButton from '../../../../components/button/button';
import CustomisedErrorCard from '../../../../components/card/errorCard';

export default function ChequesList({ setStep, referenceKey, setInnerState }: IInnerStateCheque) {
    const [installmentsData, setInstallmentsData] =
        useState<ICheqeuResponse[]>();
    const [guaranteeData, setGuaranteeData] = useState<ICheqeuResponse[]>();
    const [setadCheck, setSetadCheck] = useState<boolean>();
    const [entityRejectReasons, setEntityRejectReasons] = useState<IEntityRejectReasons[]>();
    const [rejectReasons, setRejectReasons] = useState<string[]>();
    const { setHeader } = useAppBar();
    const dispatch = useDispatch();
    const { mutateAsync: getChequeMutation, isLoading: loadingCheque } =
        useMutation(GetCheques, {
            onSuccess: (data: ICheqeuResponse[]) => {
                if (data) {
                    const guarantee = data.filter(
                        (item) => item.chequeType !== 'Installment'
                    );
                    const Installments = data.filter(
                        (item) => item.chequeType === 'Installment'
                    );
                    if (setadCheck) {

                        guarantee.map((item) => {
                            const match = entityRejectReasons?.find(itemReason => itemReason.id === item.chequeId);
                            if (match) {
                                item.confirm = false;
                            } else {
                                item.confirm = true;
                            }
                        });
                        Installments.map((item) => {

                            const match = entityRejectReasons?.find(itemReason => itemReason.id === item.chequeId);
                            if (match) {
                                item.confirm = false;
                            } else {
                                item.confirm = true;
                            }
                        });

                        setGuaranteeData(guarantee);
                        setInstallmentsData(Installments);

                    } else {
                        setGuaranteeData(guarantee);
                        setInstallmentsData(Installments);
                    }


                }
            },

            onError: (err) => {
                console.log(err);
            },
        });

    useEffect(() => {
        if (setadCheck !== undefined) {
            const requestCheque = {} as IGetCheqeuRequest;
            requestCheque.referenceKey = referenceKey!;
            getChequeMutation(requestCheque);
        }
    }, [setadCheck]);

    const randomKeyForDispatch = Math.random();
    const { mutateAsync: getFormRejectReasonsMutation } = useMutation(
        getFormRejectReasons,
        {
            onSuccess: (data: IGetFormRejectReasonsResponse[]) => {
                const request = {} as IGetCheqeuRequest;
                request.referenceKey = referenceKey!;
                setSetadCheck(data[0]?.checkBySetad ?? false);

                setEntityRejectReasons(data[0]?.entityRejectReasons)
                let arrayResaon: string[] = [];
                data[0]?.entityRejectReasons.map((item) => {
                    item.rejectReasons.map((item) => {

                        arrayResaon.push(item)
                    })
                });
                setRejectReasons(arrayResaon)
                // getChequeMutation(request);
            },
        }
    );
    useEffect(() => {
        setHeader('ثبت چک های اقساط و ضمانت', 'cheque');

        const request = {} as IGetFormRejectReasonsRequest;
        request.referenceKey = referenceKey!;

        request.form = 'Cheque';
        getFormRejectReasonsMutation(request);
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'forms' + randomKeyForDispatch }));
    }, []);
    const handleCheque = (chequeId: number, chequeType: string, confirm?: boolean) => {
        if (setadCheck) {
            if (!confirm) {
                dispatch(setchequeInfo({ chequeId, chequeType }));
                setInnerState!('chequeRegister');
            }
        } else {
            dispatch(setchequeInfo({ chequeId, chequeType }));
            setInnerState!('chequeRegister');
        }


    };
    const handleContinue = () => {
        dispatch(getNextInnerState({ nextInnerState: `formLists ${randomKeyForDispatch} ` }));
    }
    if (loadingCheque) {
        return <ChequesListSkeleton />;
    }
    return (
        <div className="container-height-drawer">
            <div className=" primaryColorLight-900 content-container">
                <div className='drawer-content'>
                    {entityRejectReasons && entityRejectReasons!.length > 0 && (
                        <div className="mt-3 mb-4">
                            <CustomisedErrorCard titleList={rejectReasons!} />
                        </div>
                    )}
                    <div>
                        {guaranteeData && (
                            <>
                                {/* <ElementTitle title="چک‌ ضمانت" /> */}
                                {guaranteeData?.map(
                                    (item: ICheqeuResponse, index: number) => {
                                        const status = `تاریخ ${item.dueDatePersian} - مبلغ ${item.amount?.toLocaleString()} ریال`;
                                        return (
                                            <>
                                                {item.sayadNumber ?
                                                    <div className='mt-2'><NestedCard isError={item.confirm === undefined ? true : item.confirm} onClick={() => {
                                                        handleCheque(
                                                            item.chequeId,
                                                            item.chequeType,
                                                            item.confirm
                                                        );
                                                    }} outPart={`چک ضمانت متقاضی- ${status} `} inPart={` شماره صیادی ${item.sayadNumber}`} /></div>
                                                    : <ListItem
                                                        title={'چک ضمانت متقاضی'}
                                                        status={status}
                                                        id={index}
                                                        key={index}
                                                        onClick={() => {
                                                            handleCheque(
                                                                item.chequeId,
                                                                item.chequeType
                                                            );
                                                        }}
                                                    />}
                                            </>
                                        )
                                    }
                                )}
                            </>
                        )}<br />
                        {installmentsData && installmentsData.length > 0 && (
                            <>
                                <ElementTitle title="چک‌های اقساط" />
                                {installmentsData?.map(
                                    (item: ICheqeuResponse, index: number) => {
                                        const title = `قسط ${ordinals[index]}`;
                                        const status = `تاریخ ${item.dueDatePersian} - مبلغ ${item.amount?.toLocaleString()} ریال`;
                                        return (
                                            <>{
                                                item.sayadNumber ? <div className='mt-2'><NestedCard outPart={` ${title}- ${status} `} isError={item.confirm === undefined ? true : item.confirm} inPart={` شماره صیادی ${item.sayadNumber}`}
                                                    onClick={() => {
                                                        handleCheque(
                                                            item.chequeId,
                                                            item.chequeType,
                                                            item.confirm
                                                        );
                                                    }}
                                                /></div> : <ListItem
                                                    title={title}
                                                    status={status}
                                                    id={index}
                                                    key={index}
                                                    onClick={() => {
                                                        handleCheque(
                                                            item.chequeId,
                                                            item.chequeType
                                                        );
                                                    }}
                                                />
                                            }
                                            </>
                                        );
                                    }
                                )}
                            </>
                        )}
                    </div>
                </div>
                <div className="py-5">
                    <CustomisedButton
                        title='ثبت و ادامه'
                        disable={false}
                        onClick={handleContinue}
                        type="submit"
                    />
                </div>
            </div>
        </div>
    );

}
const ordinals = [
    'اول',
    'دوم',
    'سوم',
    'چهارم',
    'پنجم',
    'ششم',
    'هفتم',
    'هشتم',
    'نهم',
    'دهم',
    'یازدهم',
    'دوازدهم',
    'سیزدهم',
    'چهاردهم',
    'پانزدهم',
    'شانزدهم',
    'هفدهم',
    'هجدهم',
    'نوزدهم',
    'بیستم',
    'بیست یکم',
    'بیست دوم',
    'بیست چهارم',
    'بیست پنجم',
    'بیست ششم',
    'بیست هفتم',
    'بیست هشتم',
    'بیست نهم',
    'سی ام',
    'سی یکم',
    'سی دوم',
    'سی سوم',
    'سی چهارم',
    'سی پنجم',
    'سی ششم',
    'سی هفتم',
    'سی هشتم',
    'سی نهم',
    ' چهلم',
    'چهل ام',
    'چهل یکم',
    'چهل دوم',
    'چهل سوم',
    'چهل چهارم',
    'چهل پنجم',
    'چهل ششم',
    'چهل هفتم',
    'چهل هشتم',
];
